import freeEmailList from "../free-email-list.json" with { type: "json" };

// Additional blocked domains
const additionalBlockedDomains = [
  "@ymail.com",
  "@fbook.com",
  "@gmaig.com",
  "@msn.com",
  "@gmail.cn",
  "@yaho.cn",
  "@ayahoo.com",
  "@g1mail.com",
];
const extendedFreeEmailList = freeEmailList.concat(additionalBlockedDomains);

/**
 * Check if email domain is in the free email list
 * @param {string} email
 * @returns {boolean}
 */
export function isFreeEmail(email) {
  if (!email) return false;

  const emailLower = email.toLowerCase();

  return extendedFreeEmailList.some((pattern) => {
    if (pattern.startsWith("@")) {
      // Check if email ends with this domain
      return emailLower.endsWith(pattern);
    } else if (pattern.includes("@")) {
      // Exact match for specific emails
      return emailLower === pattern;
    } else {
      // Substring match for keywords like "victorops"
      return emailLower.includes(pattern);
    }
  });
}

/**
 * Reject free email addresses on the Marketo API form
 * (#mkto-api-form / #email-nodemandbase) using the browser's validation API.
 */
export function blockFreeEmails() {
  const emailField = document.getElementById("email-nodemandbase");
  const form = document.getElementById("mkto-api-form");

  if (
    !(emailField instanceof HTMLInputElement) ||
    !(form instanceof HTMLFormElement)
  ) {
    return;
  }

  const freeEmailMessage =
    "Email not valid. Please enter your company email address.";
  // The API form's oninvalid handler replaces the validity message with
  // data-custom-error, so swap that too while a free email is entered
  const defaultCustomError = emailField.dataset.customError;

  // Validate email function
  const validateEmail = () => {
    const email = emailField.value.trim();
    if (email && isFreeEmail(email)) {
      emailField.dataset.customError = freeEmailMessage;
      emailField.setCustomValidity(freeEmailMessage);
      return false;
    } else {
      if (defaultCustomError !== undefined) {
        emailField.dataset.customError = defaultCustomError;
      }
      emailField.setCustomValidity("");
      return true;
    }
  };

  // Validate up front so a free email prefilled from saved form data makes
  // the form invalid before prefill-hide-mkto-form checks its validity
  validateEmail();

  // Revalidate while typing so a corrected email clears the error right away
  emailField.addEventListener("input", validateEmail);

  // Validate on blur (when user leaves the field)
  emailField.addEventListener("blur", () => {
    if (!validateEmail()) {
      emailField.reportValidity(); // Show the validation message immediately
    }
  });

  // Validate on form submit
  form.addEventListener(
    "submit",
    (e) => {
      if (!validateEmail()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        // Prefilled forms can have their fields hidden; show them so the
        // email can be corrected
        document
          .getElementById("mkto-api-form-fields")
          ?.classList.remove("hidden");
        emailField.reportValidity();
      }
    },
    true,
  ); // Use capture phase to run before other submit handlers
}
